import React, {Children, useEffect} from "react";
import {
    useFieldArray,
    useFormContext,
    useFormState,
} from "react-hook-form";
import {Button} from "react-bootstrap";
import "./NFormTable.css";
import {AllItemsData} from "../../Pages/Documents/SetItemPrices/SetItemsPricesDetailsRecords";
import {useTranslation} from "react-i18next";

export interface IProps {
    children?: React.ReactNode;
    toolBar?: React.ReactNode;
    showTable?: boolean;
    fieldArray?: string | any;
    onFieldValueChanged?: (
        fieldName: string,
        index: number,
        oldValue: any,
        newValue: any
    ) => void;
    emptyMessage?: string;
    showData?: boolean;
    getData?: any;
}

export const NFormTable = ({
                               children,
                               fieldArray,
                               onFieldValueChanged,
                               toolBar,
                               showTable = true,
                               emptyMessage = "No items in table...",
                               getData = [],
                               showData,
                           }: IProps) => {
    const arrayChildren = Children.toArray(children);

    const {
        register,
        control,
        watch,
        formState: {errors},
        getValues,
        setValue,
    } = useFormContext();

    const {t} = useTranslation();

    const {dirtyFields} = useFormState();
    const {fields, append, remove} = useFieldArray({
        control,
        name: fieldArray,
    });

    const watchFieldArray = watch(fieldArray);
    const controlledFields = fields.map((field, index) => {
        // console.log("field", field);
        // console.log("index", index);
        // const watchField = watch(`${fieldArray}[${index}].${field.id}`);
        // console.log("watchField", watchField);

        return {
            ...field,
            ...watchFieldArray[index],
        };
    });

    const dataToMap = showData ? getData : controlledFields;
    const handleAddNewRow = () => {
        recalculateLineNumbers("add");
        // console.log("fields.length", fields.length);
        // const newLineNo = fields.length + 1;
        // console.log("newLineNo", newLineNo);
    };

    const handleRemoveRow = (index: number) => {
        // remove(index);
        recalculateLineNumbers("remove", index);
        // const newFieldArray = getValues(controlledFields);
        // newFieldArray.forEach((field: any, index: number) => {
        //     if (field.lineNo !== index + 1) {
        //         field.lineNo = index + 1;
        //     }
        // });
        // setValue(fieldArray, newFieldArray);
    };

    const recalculateLineNumbers = (operation: "add" | "remove", index?: number) => {
        console.log(watchFieldArray);
        const newFieldArray = watchFieldArray;//getValues(controlledFields);

        if (operation === "add") newFieldArray.push({});
        if (operation === "remove") newFieldArray.splice(index, 1);

        let lineIndex = 1;
        newFieldArray.forEach((field: any) => {
            field.lineNo = lineIndex++;
        });
        setValue(fieldArray, newFieldArray);
    };

    return (
        <>
            <div className={"w-100"}>
                <Button
                    variant=""
                    className="btn btn-sm btn-outline-primary mb-3 me-3"
                    onClick={handleAddNewRow}
                >
                    <i className="fa-solid fa-plus me-2"></i>
                    {t("New row")}
                </Button>
                {toolBar}
                {showTable && (
                    <div className={"scroll"}>
                        <table className={"table table-sm table-hover"}>
                            <thead>
                            <tr>
                                {arrayChildren &&
                                    arrayChildren.map((field: any, index) => {
                                        return (
                                            <th key={index} className="fw-normal">
                                                {field.props?.title}
                                            </th>
                                        );
                                    })}
                                <th className="fw-normal">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {dataToMap.map((field: any, index: number) => {
                                return (
                                    <tr key={index}>
                                        {arrayChildren &&
                                            arrayChildren.map((column: any, columnIndex) => {
                                                if (column.props.required === true) {
                                                    register(
                                                        `${fieldArray}[${index}].${column.props.fieldName}`,
                                                        {required: true}
                                                    );
                                                }
                                                return (
                                                    <td style={{margin: "0 auto"}} key={columnIndex}>
                                                        {React.cloneElement(column, {
                                                            fieldName: `${fieldArray}[${index}].${column.props.fieldName}`,
                                                            showBorder: false,
                                                            title: undefined,
                                                            index: index,
                                                            value: field[column.props.fieldName],
                                                            tableName: fieldArray,
                                                            tableFieldName: column.props.fieldName,
                                                        })}
                                                    </td>
                                                );
                                            })}
                                        <td className={"text-center"} style={{width: 50}}>
                                            <div
                                                className={"text-danger"}
                                                style={{cursor: "pointer"}}
                                                onClick={() => handleRemoveRow(index)}
                                            >
                                                <i className="fa-solid fa-trash-can cursor"></i>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                        {showData
                            ? ""
                            : controlledFields.length === 0 && (
                            <div className={"w-100 text-center h5 pt-3"}>
                                {emptyMessage}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
